import React from 'react'
import { Link } from 'react-router-dom';
import '../Estilos/menu.css';
import 'bootstrap/dist/css/bootstrap.css';

import logo from '../New Template/images/LogoPcService.png';
//import { auth } from './firebase' ;
import { useAuth } from '../contextos/AuthProvider';
import '../Estilos/EstiloSap.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRectangleXmark } from "@fortawesome/free-solid-svg-icons";


export default function Navbar() {
  // const fondo = {backgroundColor:'#71ba8d'}
  //const ancho ={Width:220}
  //const tam = { marginBottom: '0' }
  const tamLogo = { maxWidth: '55%', marginRight: '20px', height: '30px', marginLeft: '35px', marginTop: '10px' }
  //const tituloPantalla={borderBottom:'5px solid #fcba16', backgroundColor: '#afafaf' , padding:'0px', margin:'0px'}
  const { signout, PerfilUsuario } = useAuth();
  if (PerfilUsuario) {
    return (
     
        <div>
         <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.4.1/css/bootstrap.min.css"></link>
  
          <nav style={{ marginBottom: '0px', paddingTop: '0px', paddingBottom: '0px' }} className="navbar navbar-expand-lg navbar-light bg-light">

            <div style={{marginBottom: '0px',}} className="container-fluid tituloPantalla" >

              <ul className="navbar-nav d-flex flex-row">
                <p style={{ color: '#ffc01d', fontSize: '20px', marginTop: '5px' }}>{PerfilUsuario.NombreComercial}</p>
                <Link to="/"><img src={logo} style={tamLogo} alt="LogoPcService"></img></Link>


                <li className="nav-item me-3 me-lg-0 dropdown">
                  <a className="nav-link dropdown-toggle" data-toggle="dropdown" href="/#" role="button" aria-haspopup="true" aria-expanded="false">
                    <i className="fa fa-user"></i>
                  </a>
                  <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                    <li>
                      <Link to="/Documentos/CrearDocumento">Crear Documento</Link>
                    </li>
                    <li>
                      <Link to="/Clientes/GeneralCliente">Datos Cliente</Link>
                    </li>
                    <li>
                      <Link to="/Documentos/Cotizaciones">Cotizaciones</Link>
                    </li>
                  </ul>
                </li>


                <li className="nav-item me-3 me-lg-0 dropdown">
                  <a className="nav-link dropdown-toggle" data-toggle="dropdown" href="/#" role="button" aria-haspopup="true" aria-expanded="false">
                    <i className="fa fa-paperclip"></i>
                  </a>
                  <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                    <li>
                      <Link to="/Documentos/Facturas">Facturas</Link>
                    </li>
                    <li>
                      <Link to="/Documentos/Tiquetes">Tiquetes</Link>
                    </li>
                    <li>
                      <Link to="/Documentos/NCs">Notas Crédito</Link>
                    </li>
                    <li>
                      <Link to="/Documentos/NDs">Notas Débito</Link>
                    </li>
                    <li>
                      <Link to="/Documentos/Exportacion">Facturas Exportación</Link>
                    </li>
                    <li>
                      <Link to="/Documentos/RecibosPago">Recibos Elect. Pago</Link>
                    </li>
                  </ul>
                </li>

                <li className="nav-item me-3 me-lg-0 dropdown">
                  <a className="nav-link dropdown-toggle" data-toggle="dropdown" href="/#" role="button" aria-haspopup="true" aria-expanded="false">
                    <i className="fa fa-truck"></i>
                  </a>
                  <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                    <li>
                      <Link to="/Productos/CatalogoGeneral">Catálogo</Link>
                    </li>
                    <li>
                      <Link to="/Documentos/Compras">Compras</Link>
                    </li>
                    <li>
                      <Link to="/Documentos/SubirCompras">Subir Compras</Link>
                    </li>
                    <li>
                      <Link to="/Documentos/FECs">Facturas Elect. Compras</Link>
                    </li>
                  </ul>
                </li>

                <li className="nav-item me-3 me-lg-0 dropdown">
                  <a className="nav-link dropdown-toggle" data-toggle="dropdown" href="/#" role="button" aria-haspopup="true" aria-expanded="false">
                    <i className="fa fa-university"></i>
                  </a>
                  <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                    <li>
                      <Link to="/Pagos">Pagos y Planes</Link>
                    </li>
                    <li>
                      <Link to="/MisDatos">Preferencias</Link>
                    </li>
                    <li>
                      <Link target='_blank' to="http://smartfecr.com:2010">Sistema Anterior</Link>
                    </li>

                  </ul>
                </li>


                <li className="nav-item me-3 me-lg-0 dropdown">
                  <a className="nav-link dropdown-toggle" data-toggle="dropdown" href="/#" role="button" aria-haspopup="true" aria-expanded="false">
                    <i className="fa fa-info"></i>
                  </a>
                  <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                    <li>
                      <Link to="/Reporteria/Reportes">Reportes Generales</Link>
                    </li>
                    <li>
                      <Link to="/Gestionusuarios/ListaUsuarios">Nosotros</Link>
                    </li>
                  </ul>
                </li>






              </ul>
              <button style={{ position: 'fixed', right: '0', marginRight: '15px', backgroundColor: '#f3f3f3', width: '50px' }} className="botonCerrar" onClick={async () => { await signout(); console.log("salir") }}><FontAwesomeIcon icon={faRectangleXmark} /></button>
            </div>

          </nav>
        </div>
     
    )
  }
}
/*
<div  className="main-block">
<nav>
<div className="info">
<a href="/#" className="">Logo</a>
<a href="/#" data-target="mobile-demo" className=""><i className="material-icons">menu</i></a>
<ul id="nav-mobile" className="">
<li><a href="sass.html">Administración</a></li>
<li><a  className=""  href="#!" data-hover="hover" data-target="dropdown2">Clientes</a></li>
<li><a href="collapsible.html">Inventario</a></li>
 
</ul>
</div>

*}
{/* 
<div className="nav-content">
<ul className="tabs tabs-transparent">
<li className="tab"><a href="#test1">Test 1</a></li>
<li className="tab"><a className="active" href="#test2">Test 2</a></li>
<li className="tab"><a href="#test3">Test 3</a></li>
</ul>
</div>
*/
/*  </nav>
 

 <ul id="dropdown2" className=""  data-hover="true">
   <li> <Link to="/Clientes/PuntoVenta">Punto Venta</Link></li>
   <li> <Link to="/Clientes/Caja">Caja</Link></li>
   <li className="divider"></li>
   <li><a href="#!">three</a></li>
</ul>


 <ul className="sidenav" id="mobile-demo">
   <li><a href="sass.html">Administración</a></li>
   <li><a href="badges.html">Clientes</a></li>
   <li><a href="collapsible.html">Inventario</a></li>
 </ul>

{/*  
 <div id="test1" className="col s12">Test 1</div>
 <div id="test2" className="col s12">Test 2</div>
 <div id="test3" className="col s12">Test 3</div>
 
   </d   


 <li className="nav-item me-3 me-lg-0 dropdown">
              <a className="nav-link dropdown-toggle" data-toggle="dropdown" href="/#" role="button" aria-haspopup="true" aria-expanded="false">
                <i className="fa fa-suitcase"></i>
              </a>
              <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                <li>
                  <Link to="/Companias/GeneralCia">Compañias</Link>
                </li>
                       
              </ul>
            </li>


 {*/

